import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { DropdownModule } from "ngx-dropdown";
import { ModalModule } from "ngx-modal";
import { NgxToggleModule } from "ngx-toggle";
import { MultiSelectModule } from "primeng/multiselect";
import { AccountStatementViewComponent } from "./account-statement-view/account-statement-view.component";
import { AccountStatementComponent } from "./account-statement/account-statement.component";
import { ClaimsViewComponent } from "./claims-view/claims-view.component";
import { AddClaimFormModalComponent } from "./claims-view/modals/add-claim-form-modal/add-claim-form-modal.component";
import { ClaimsComponent } from "./claims/claims.component";
import { FinancialRoutingModule } from "./financial-routing.module";
import { FinesViewComponent } from "./fines-view/fines-view.component";
import { AddFineFormModalComponent } from "./fines-view/modals/add-fine-form-modal/add-fine-form-modal.component";
import { FinesComponent } from "./fines/fines.component";
import { RentComponent } from "./rent/rent.component";
import { SalesComponent } from "./sales/sales.component";
import { CollectClaimFormModalComponent } from "./claims-view/modals/collect-claim-form-modal/collect-claim-form-modal.component";
import { ViewPaymentModalComponent } from "./claims-view/modals/view-payment-modal/view-payment-modal.component";
import { EtaTaxesListingComponent } from "./eta-taxes-listing/eta-taxes-listing.component";
import { ManageEtaTaxesComponent } from "./manage-eta-taxes/manage-eta-taxes.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { EtaClaimsViewComponent } from './eta-claims-view/eta-claims-view.component';
import { EtaReportsComponent } from './eta-reports/eta-reports.component';
import { AllClaimsComponent } from "./all-claims/all-claims.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FinancialRoutingModule,
    NgbModule.forRoot(),
    ModalModule,
    NgxToggleModule,
    DropdownModule,
    MultiSelectModule,
    NgMultiSelectDropDownModule,
    NgSelectModule,
  ],
  declarations: [
    SalesComponent,
    RentComponent,
    AccountStatementComponent,
    AccountStatementViewComponent,
    ClaimsComponent,
    ClaimsViewComponent,
    FinesComponent,
    FinesViewComponent,
    AddFineFormModalComponent,
    AddClaimFormModalComponent,
    CollectClaimFormModalComponent,
    ViewPaymentModalComponent,
    EtaTaxesListingComponent,
    ManageEtaTaxesComponent,
    EtaClaimsViewComponent,
    EtaReportsComponent,
    AllClaimsComponent,
  ],
})
export class FinancialModule {}



// WEBPACK FOOTER //
// ./src/app/financial/financial.module.ts